module.exports = __webpack_public_path__ + "img/map@2x.1aa5c9d9.png";